import moment from 'moment'

const today = (locale) =>  moment().locale(locale).format('LL')
const nextWeek = (locale) =>  moment().add(7, 'days').locale(locale).format('LL')

export {
  today,
  nextWeek
}
